import React from "react";
import { Container, Row, Col } from "reactstrap";
import "./section-heading.css";

export const SectionHeading = props => (
  <Container fluid className="py-5 my-5">
    <Row>
      <Col lg="12" className="text-center">
        <h2 className="section-heading__title">{props.title}</h2>
        {props.subtitle ? <small>{props.subtitle}</small> : null}
        <hr className="my-2" />
      </Col>
    </Row>
  </Container>
);



// WEBPACK FOOTER //
// ./src/components/SectionHeading/SectionHeading.js